import React, { FC, memo } from 'react'
import cn from 'classnames'
import { useStore } from 'store'
import { observer } from 'mobx-react'
import { ReactCompareSlider, ReactCompareSliderImage } from 'react-compare-slider'
import { staticMultimedia } from 'utils'

interface IProps {
}

export const CompareSliderImage: FC<IProps> = memo(({}) => {
  return (
    <ReactCompareSlider
      itemOne={
        <ReactCompareSliderImage
          src={staticMultimedia.welcome1}
          alt="VR Client"
        />
      }
      itemTwo={
        <ReactCompareSliderImage
          src={staticMultimedia.welcome2}
          alt="Web Client"
        />
      }
    />
  )
})
